var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('user-route-tabs',{attrs:{"user-id":_vm.userId}}),_c('user-address-form',{attrs:{"user-id":_vm.userId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }